<template>
    <div class="video" style="padding: 56.25% 0 0 0; position: relative">
      <iframe
        :src="videoURL"
        frameborder="0"
        webkitallowfullscreen
        mozallowfullscreen
        allowfullscreen
        style="
          background: '#e9e9e9';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        "
      />
    </div>
</template>

<script>
export default {
    name: 'FullWidthVideo',
    props: ['videoURL']
}
</script>

<style>

</style>